<script lang="ts">
    import type {IPagoCard, IPagoDetalles} from "../../../interfaces";
    import {getFormatter} from "../../../utils";
    import PagoAppCardCuotas from "./PagoAppCardCuotas.svelte";
    import PagoAppDetalles from "./PagoAppDetalles.svelte";

    const formatter = getFormatter();

    export let data: IPagoCard = null;
    export let detalles: IPagoDetalles = null;
    export let reciboUrl: string;
    export let filtered: Array<string> = null;

    let activeTab = "cuotas";
    let cmp: any;

    export let cuotaOrden = false;
    export let baseStatic;

    export function refresh() {
        if (cmp) {
            cmp.refresh();
        }
    }
</script>
<div class="back-white p-1 m:p-ii radius">
    <div class="gHeader">
        <div class="image back-gray" style="height: 50px">
            {#if data.icon === 'generales'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-generales.svg"
                     alt="Seguros generales">
            {:else if data.icon === 'vida'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-vida.svg" alt="Seguros vida">
            {:else if data.icon === 'vehiculos'}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-vehiculos.svg"
                     alt="Seguros vehículos">
            {:else}
                <img height="50" width="50" src="{window['baseStatic']}pagos_app/pix/siniestros-generales.svg"
                     alt="Seguros generales">
            {/if}
        </div>
        <div class="info">
            <p style="font-weight: 600; font-size: .9rem">{data.productLabel}</p>
            <p style="font-weight: 600; font-size: .9rem">No. {data.productId}</p>
            {#if data.endoso}
                <p style="font-size:.9rem">Endoso: {data.endoso}</p>
            {/if}
        </div>
        <div class="nav m:mt-ii">
            <div class="box-l sx-2">
                <div class:active={activeTab==='cuotas'} class="nav-tab pb-i pointer"
                     on:click={()=> activeTab = 'cuotas'}>Cuotas disponibles
                </div>
                {#if detalles && detalles.fechaLimite}
                    <div class:active={activeTab==='detalles'} class="nav-tab pb-i pointer"
                         on:click={()=> activeTab = 'detalles'}>Ver detalles
                    </div>
                {/if}
            </div>
        </div>
        <div class="tags">
            <div class="naui-tag">{data.tipoPago}</div>
        </div>

    </div>
    {#if activeTab === 'cuotas'}
        <PagoAppCardCuotas bind:filtered={filtered} bind:this={cmp} bind:data={data} bind:reciboUrl={reciboUrl}
                           on:selected/>
    {:else if activeTab === 'detalles'}
        <PagoAppDetalles data="{detalles}"/>
    {/if}
    {#if cuotaOrden}
        <div>Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante.</div>
    {/if}
</div>
<style>

    .gHeader .image {
        grid-area: image;
    }

    .gHeader .info {
        grid-area: info;
    }

    .gHeader .nav {
        grid-area: nav;
    }

    .gHeader .tags {
        grid-area: tags;
    }

    .gHeader {
        display: grid;
        grid-gap: .5rem;
        grid-template-columns: 50px 200px 1fr auto;
        grid-template-areas: 'image info nav tags';
    }

    @media (max-width: 1024px) {
        .gHeader {
            grid-template-columns: 50px 1fr auto;
            grid-template-areas: 'image info tags''nav nav nav';
        }

    }

    .naui-tag {
        background: #E5E5E5;
        color: #5C5C5C;
        border: none;
    }

    .nav-tab {
        color: #525252;
        border-bottom: 1px solid transparent;
    }

    .nav-tab.active {
        color: var(--secondary);
        border-bottom: 1px solid var(--secondary);
    }
</style>